import AES from "crypto-js/aes";
import Utf8 from "crypto-js/enc-utf8";

// Obfuscation of what sits on disk, not secrecy: the key ships inside the bundle.
// Same key as our other TV apps, so a stored playlist reads the same everywhere.
const key = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9eyJpZCI6IjY";

export const encrypt = (str) => {
    try {
        return AES.encrypt(str, key).toString();
    } catch (e) {
        return "";
    }
};

// `encrypt` always writes OpenSSL's salted format ("Salted__…"). CryptoJS decrypts anything else with a random
// salt, into random bytes that are now and then valid text, so it is refused up front.
const SALTED_PREFIX = "U2FsdGVkX1";

export const decrypt = (str) => {
    if (typeof str !== "string" || str.indexOf(SALTED_PREFIX) !== 0) return "";
    try {
        return AES.decrypt(str, key).toString(Utf8);
    } catch (e) {
        return "";
    }
};
